<template>
  <a-card :bordered="false" :title="storeId == 0 ? '添加门店' : '修改门店'">
    <a-form-model
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
      :label-col="currentFormLayout.labelCol"
      :wrapper-col="currentFormLayout.wrapperCol"
    >
      <a-form-model-item label="门店名称" prop="storeName">
        <a-input v-model="ruleForm.storeName" placeholder="请输入门店名称" :maxLength="50"></a-input>
      </a-form-model-item>
      <a-form-model-item label="地址">
        <a-cascader
          :options="provinceList"
          @change="onCityChange"
          :value="defaultCityValue"
          :showSearch="{ filter }"
          changeOnSelect
          placeholder="请选择地址"
          style="max-width:400px;"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-input v-model="ruleForm.storeAddress" placeholder="请输入门店地址" :maxLength="100"></a-input>
      </a-form-model-item>
      <a-form-model-item label="电话" prop="storePhone">
        <a-input v-model="ruleForm.storePhone" placeholder="请输入门店电话" :maxLength="20"></a-input>
      </a-form-model-item>
      <a-form-model-item label="状态" :required="true">
        <a-radio-group v-model="ruleForm.status">
          <a-radio :value="1">显示</a-radio>
          <a-radio :value="2">隐藏</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="submitForm" :loading="submitLoading">
          {{ storeId == 0 ? '添加门店' : '修改门店' }}
        </a-button>
        <a-button @click="goBack">返回</a-button>
      </a-form-model-item>
    </a-form-model>

  </a-card>
</template>

<script>
export default {
  name: 'AddShop',
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 17 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 16 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 14 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 14 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 11 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 11 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      storeId: this.$route.query.shopId,
      ruleForm: {
        status: 1,
        storeName: '',
        storeAddress: '',
        storePhone: '',
        storeId: this.$route.query.shopId,
        countyId: undefined,
        provinceId: undefined,
        cityId: undefined,
        // storeMangerId: 0,
        // storeMangerName: '',
        // storeMangerPhone: '',
        merchantId: this.$store.getters.userInfo.merchantId
      },
      defaultCityValue: [],
      queryParams: {},
      provinceList: [],
      rules: {
        storeName: [{ required: true, message: '请输入门店名称', trigger: 'blur' }],
        storePhone: [
          { validator: this.handPhone, trigger: 'blur' }
        ]
      }
    }
  },
  activated() {
    this.storeId = this.$route.query.shopId
    this.getMerchantStore()
    this.getProvinceList()
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ShopList', title: '门店管理' }])
  },
  methods: {
    handPhone(rule, value, callback) {
      if (!value || (value && /^400-[016789]\d{2}-\d{4}$/.test(value)) || (value && /^400[016789]\d{6}$/.test(value)) || (value && /^1[3456789]\d{9}$|^0\d{2,3}-?\d{7,8}$/.test(value))) {
        callback()
      } else {
        callback(new Error('请输入正确400或手机号码'))
      }
    },
    // 获取城市集合
    getProvinceList() {
      this.getHttpServices()
        .getBaseService()
        .get('province/getProvinceCityCounty')
        .then(res => {
          this.provinceList = res
          this.getLogUtils().logWithTag('provinceList', this.provinceList)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    onCityChange(value, selectedOptions) {
      // this.getLogUtils().logWithTag(value, selectedOptions);
      if (value && value.length) {
        this.ruleForm.provinceId = value[0] ? value[0] : ''
        this.ruleForm.cityId = value[1] ? value[1] : ''
        this.ruleForm.countyId = value[2] ? value[2] : ''
        this.defaultCityValue = [value[0], value[1], value[2]]
        this.getLogUtils().logWithTag('defaultCityValue', this.defaultCityValue)
      } else {
        this.defaultCityValue = []
        this.ruleForm.provinceId = undefined
        this.ruleForm.cityId = undefined
        this.ruleForm.countyId = undefined
      }
    },
    //授信设置提交
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.saveData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    //保存接口
    saveData() {
      this.submitLoading = true
      this.getHttpServices()
        .getUserService()
        .post('user/merchantStore/addOrUpdateMerchantStore', this.ruleForm)
        .then(res => {
          let text = this.storeId == 0 ? '添加' : '修改'
          this.$message.success(text + '门店成功')
          setTimeout(() => {
            this.$router.push({
              name: 'ShopList',
              query: {
                updateFlag: this.storeId
              }
            })
          }, 500)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => (this.submitLoading = false))
    },
    //获取门店信息
    getMerchantStore() {
      if (this.storeId != 0) {
        this.getHttpServices()
          .getUserService()
          .post('user/merchantStore/getMerchantStore/' + this.storeId)
          .then(res => {
            this.ruleForm = res
            this.defaultCityValue = [res.provinceId, res.cityId, res.countyId]
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      } else {
        this.defaultCityValue = []
        this.$refs.ruleForm.resetFields()
        this.ruleForm.storeAddress = ''
        // this.ruleForm.storeMangerId = ''
        // this.ruleForm.storeMangerName = ''
        // this.ruleForm.storeMangerPhone = ''
      }
    },
    //绑定店长
    bandShopIdData(data) {
      this.ruleForm.storeMangerId = data.userId
      this.ruleForm.storeMangerName = data.roleName
      this.ruleForm.storeMangerPhone = data.userMobile
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //返回
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
@import '../../../CustomPage.less';

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.pl10 {
  padding-left: 10px;
}
</style>
